const user = {
  state: {
    perfectInfo: {
      fullName: '',
      hospitalId: '',
      hospitalName: '',
      deparmentId: '',
      deparmentName: '',
      dutyId: ''
    }
  },
  mutations: {
    SET_PERFECT (state, info) {
      state.perfectInfo = info
    }
  },
  actions: {

  }
}
export default user
